export default "__VITE_ASSET__caf3e811__"